<template>
  <v-content>
    <div
      ref="contentHeader"
      style="position: sticky; top:55px; z-index: 2; width: 100%"
    >
      <content-filter
        v-if="isFilterShow()"
        ref="contentFilter"
      />
    </div>
    <v-container
      id="inner-content"
      wrap
      justify-center
      :style="{position : 'relative', paddingTop : 20 + 'px'}"
    >
      <router-view
        style="padding-bottom:200px;"
      />
    </v-container>
  </v-content>
</template>
<script>
import ContentFilter from './ContentFilter.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    'content-filter': ContentFilter
  },
  data () {
    return {
      crumbsProduct: '',
      crumbsCategory: '',
      crumbsDetail: '',
      routeHistory: ['_all', '_category', '_detail'],
      crumbs: [],
      depth: 0,
      contentTop: 0
    }
  },
  computed: {
    isSelect: function () {
      let code = this.$route.params.id
      if (!code) {
        return false
      }
      const isCode = this.$store.getters.selected.find(item => {
        return item.code === code
      })
      return isCode
    },
    productCode: function () {
      return this.$route.name.split('_')[0]
    },
    categoryCode: function () {
      return this.$route.params.category
    },
    isLicensedProductPage: function () {
      const productType = this.$route.path.split('/')[2]
      if (this.isFilterShow() && productType === 'licensedproducts') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    '$route.params' () {
      this.initCrumbs()
    },
    '$route.path' (newPath, old) {
      // 경로가 변경 될 때 다른 카테고리 또는 국가 페이지 로 이동인지 체크
      const nextCategory = newPath.split('/')[2]
      const prevCategory = old.split('/')[2]
      const nextLang = newPath.split('/')[1]
      const prevLang = old.split('/')[1]

      if (nextCategory !== prevCategory || nextLang !== prevLang) {
        this.$store.commit('initFilterParams')
      }
      if (this.$refs.contentFilter) {
        this.$refs.contentFilter.initUI()
      }
    }
  },
  beforeMount () {
    this.initCrumbs()
  },
  methods: {
    ...mapGetters({
      findSeletedCode: 'findSeletedCode'
    }),
    initCrumbs () {
      this.crumbsProduct = this.crumbsCategory = this.crumbsDetail = ''
      this.getProductInfo()

      if (this.isVaildRoute()) {
        this.getCrumbs()
      } else {
        this.crumbs = []
      }
    },
    isHome () {
      const routeName = this.$route.name
      if (routeName === 'home') {
        return true
      } else {
        return false
      }
    },
    isNotHome () {
      return !this.isHome()
    },
    isBreadcrumbsShow () {
      const routeName = this.$route.name

      if (routeName === 'home' || routeName === 'selected_list' || routeName === 'search_list') {
        return false
      } else {
        return true
      }
    },
    isDetail () {
      const routeName = this.$route.name
      if (routeName.includes('detail')) {
        return true
      } else {
        return false
      }
    },
    isFilterShow () {
      if (this.isHome() ||
        this.$route.name === 'selected_list' ||
        this.$route.name === 'search_list' ||
        this.depth !== 2) {
        return false
      }

      return true
    },
    getProductInfo () {
      if (this.$route.name) {
        this.crumbsProduct = this.$route.name.split('_')[0]
      }
    },
    getCategoryInfo (callback) {
      let categoryCode = this.$route.params.category
      const params = {
        lang: this.$route.params.lang,
        product: this.crumbsProduct
      }
      let that = this
      if (categoryCode) {
        return new Promise((resolve, reject) => {
          that.$http.get('/api/categories/' + categoryCode + '/', { params: params })
            .then(response => {
              this.crumbsCategory = response.data.name
              resolve()
            })
        })
      } else {
        return false
      }
    },
    getDetailInfo (callback) {
      if (this.isDetail()) {
        const productCode = this.$route.params.id
        const lang = this.$route.path.split('/')[1]
        const url = '/api/products/' + this.crumbsProduct + '/' + productCode + '/?lang=' + lang
        let that = this
        return new Promise((resolve, reject) => {
          that.$http.get(url)
            .then(response => {
              this.crumbsDetail = response.data.name
              resolve()
            })
        })
      } else {
        return false
      }
    },
    isVaildRoute () {
      const routeName = this.$route.name || undefined
      return !(!routeName || routeName.includes('home') || routeName.includes('search') || routeName.includes('selected'))
    },
    // Crumbs 깜박거림 제거, async function으로 조금 깔끔하게.
    getCrumbs: async function () {
      const routePath = this.$route.name.split('_')
      const categoryPromise = this.getCategoryInfo()
      const detailPromise = this.getDetailInfo()
      await Promise.all([categoryPromise, detailPromise])

      this.crumbs = []
      for (this.depth = 1; this.depth <= routePath.length; this.depth++) {
        const DEPTH_DEFINE = { PRODUCT: 1, CATEGORY: 2, DETAIL: 3 }
        const crumb = {
          href: this.crumbsCategory ? this.crumbsProduct + this.routeHistory[this.depth - 1] : this.crumbsProduct + this.routeHistory[0],
          disable: (this.depth === routePath.length)
        }

        switch (this.depth) {
          case DEPTH_DEFINE.PRODUCT:
            crumb['text'] = this.$t('variables.' + this.crumbsProduct)
            break
          case DEPTH_DEFINE.CATEGORY:
            crumb['text'] = this.crumbsCategory || this.$t('message.all')
            break
          case DEPTH_DEFINE.DETAIL:
            crumb['text'] = this.crumbsDetail
            break
        }
        this.crumbs.push(crumb)
      }
      this.depth = this.depth - 1
    },
    async allSelect () {
      if (this.productCode === 'selected') return
      const items = await this.getAllItem()
      this.$store.commit('clearItem', {
        product: this.productCode,
        category: this.categoryCode
      })
      this.$store.commit('selectAllItem', items)
      return false
    },
    async getAllItem () {
      // 진작 count를 알 수 있다면 좋을텐데.. limit를 -1로 줘서 전부 받거나 0으로 줘서 전부 받고싶은데.. 안된다.
      // TODO : API좀 수정해야할 것 같은데 장고 API 아직 익숙치 않아서 우선 TODO로 남긴다
      const LIMIT = 9999
      const response = await this.$http.get(`/api/products/simple/${this.productCode}/`, { params: { category: this.categoryCode, lang: this.$route.params.lang, limit: LIMIT } })
      const items = response.data.results.map((item) => {
        item.product = this.productCode
        return item
      })
      return items
    },
    allUnSelect () {
      if (this.productCode === 'selected') return
      this.$store.commit('clearItem', {
        product: this.productCode,
        category: this.categoryCode
      })
    },
    detailToggle () {
      this.$eventBus.$emit('detailToggle', this.$route.params.id)
    },
    goTo (path) {
      this.$router.push({ name: path })
    }
  }
}
</script>
<style>
* {
  word-break: keep-all;
}

#content-breadcrumbs .v-toolbar__content{
  height: 30px !important;
}

#content-breadcrumbs .v-breadcrumbs{
  padding: 0px !important;
}

#inner-content {
  overflow: hidden;
}

@media (min-width: 1904px) {
  #inner-content {
    max-width: 1185px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/Content.vue